export const DealsWidgetConfig = {
  componentTypeKey: "DealsWidget",

  baseHtmlClass: "deals_widget",
  selector: ".deals_widget",

  datasetConfigKey: "deals_widget__config",
  configUrlDatasetConfigKey: "config_url",
  dealsBaseUrlDatasetConfigKey: "deals_base_url",
  stylesheetPathDatasetConfigKey: "stylesheet_path",
  initialDealCountDatasetConfigKey: "initial_deal_count",

  uninitializedHtmlClass: "deals_widget--uninited",
  initializedHtmlClass: "deals_widget--inited",
  notInitializedSelector: ".deals_widget:not(.deals_widget--inited)",

  loadedEventName: "Rankers.DealsWidget:Loaded",
  initializedEventName: "Rankers.DealsWidget:Initialized",
  openEventName: "Rankers.DealsWidget:Open",
  closeEventName: "Rankers.DealsWidget:Close",
  dataLoadedEventName: "Rankers.DealsWidget:DataLoaded",
  dataErrorEventName: "Rankers.DealsWidget:DataError",
};
